import store from "@/store";
import { useIntersectionObserver } from "@vueuse/core";

const ProductInsights = {
  inserted: function (el, binding) {
    const observer = useIntersectionObserver(el, ([{ isIntersecting }]) => {
      if (isIntersecting) {
        store.commit("addToProductInsightsBatch", {
          productId: binding.value,
          type: binding.arg || "views",
        });
        observer.stop();
      }
    });
  },
};

export default ProductInsights;
